// process.env.REACT_APP_BASE_URL;
// const BASE_URL = import.meta.env.VITE_BASE_URL;
// export const getAllDestinationsEndpoint = {
//   url: `/api/destination/get-destinations`,
//   method: "GET",
//   withCredentials: false,
// };

// export const addDestinationEndpoint = {
//   url: `/api/destination/add-destination`,
//   method: "POST",
//   withCredentials: false,
// };

export const loginEndpoint = {
  url: `/api/user/login`,
  method: "POST",
  withCredentials: true,
};

export const sendOtpEndpoint = {
  url: `/api/user/reset`,
  method: "POST",
  withCredentials: true,
};

export const verifyOtpEndpoint = {
  url: `/api/user/reset/verify`,
  method: "POST",
  withCredentials: true,
};

export const updatePasswordEndpoint = {
  url: `/api/user/reset/newpassword`,
  method: "POST",
  withCredentials: true,
};

export const signUpEndpoints = {
  url: `/api/user/register`,
  method: "POST",
  withCredentials: true,
};

export const createRideEndpoints = {
  url: `/api/rides/`,
  method: "POST",
  withCredentials: true,
};
export const updateRideEndpoints = {
  url: `/api/rides/`,
  method: "PATCH",
  withCredentials: true,
};
export const cancelRideEndpoints = {
  url: `/api/rides/`,
  method: "DELETE",
  withCredentials: true,
};
export const searchRideEndpoints = {
  url: `/api/rides/search`,
  method: "GET",
  withCredentials: true,
};
export const getRideRequestsEndpoints = {
  url: `/api/requests/me`,
  method: "GET",
  withCredentials: true,
};
export const myRidesEndpoint = {
  url: `/api/rides/me`,
  method: "GET",
  withCredentials: true,
};
export const reqToJoinEndpoint = {
  url: `/api/requests/`,
  method: "POST",
  withCredentials: true,
};

export const getRideDetailsEndpoint = {
  url: `/api/rides/details/`,
  method: "GET",
  withCredentials: true,
};

export const setReqStatusEndpoint = {
  url: `/api/rides/`,
  method: "PATCH",
  withCredentials: true,
};

export const addInterestEndpoint = {
  url: `/api/rides/interest`,
  method: "POST",
  withCredentials: true,
};

export const getTopRequestedRoutesEndpoint = {
  url: `/api/rides/interest/top`,
  method: "GET",
  withCredentials: true,
};

export const getInterestedUsersEndpoint = {
  url: `/api/rides/interest/check`,
  method: "GET",
  withCredentials: true,
};

//TODO
export const addFeedbackEndpoint = {
  url: `/api/user/feedback`,
  method: "POST",
  withCredentials: true,
};

export const deleteRequestEndpoint = {
  url: "/api/requests/",
  method: "DELETE",
  withCredentials: true,
};
// External APIs
export const photonEndpoint = {
  url: `https://photon.komoot.io/api/`,
  method: "GET",
  withCredentials: false,
};

// Recurring APIs
export const addRecurringRequestEndpoint = {
  url: "/api/recurring/request",
  method: "POST",
  withCredentials: true,
};
export const getRecurringGroupEndpoint = {
  url: "/api/recurring/",
  method: "GET",
  withCredentials: true,
};
export const updateRecurringStatusEndpoint = {
  url: "/api/recurring/status",
  method: "PATCH",
  withCredentials: true,
};
export const getRecurringRidesEndpoint = {
  url: "/api/recurring/rides/",
  method: "GET",
  withCredentials: true,
};
